"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBaseFlowPresent = exports.cardsDetails = exports.findObjectInListById = exports.modifyObjectWithFactorById = exports.modifyObjectWithFactor = void 0;
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
// This method updates the JSON array with the additional parameter passed from the calling fn.
function modifyObjectWithFactor(obj, factor, tobeChecked, tobeChanged) {
    var matchedObject = obj.find(function (value) { return value[factor] === tobeChecked; });
    if (matchedObject) {
        matchedObject[factor] = tobeChanged;
    }
    return obj;
}
exports.modifyObjectWithFactor = modifyObjectWithFactor;
// This method modifies the JSON array with the new factor, provided the ID passed is matched.
function modifyObjectWithFactorById(obj, idTobeModified, factor, tobeChanged) {
    obj.find(function (_a) {
        var id = _a.id;
        return id === idTobeModified;
    })[factor] = tobeChanged;
    return obj;
}
exports.modifyObjectWithFactorById = modifyObjectWithFactorById;
function findObjectInListById(list, id) {
    return list.find(function (obj) { return obj.id === id; });
}
exports.findObjectInListById = findObjectInListById;
function cardsDetails(cards, cardClassName) {
    return cards.map(function (card, index) {
        var actualCardName = card.name;
        var cardNameLowercase = actualCardName && actualCardName.toLowerCase();
        return (React.createElement("div", { key: "card" + index, className: cardClassName },
            React.createElement("img", { className: "cardsComponent cardsComponent_secondary", alt: "", src: card.cardArt }),
            React.createElement(pp_react_1.Text, { className: "cardsComponent", size: "sm" },
                card.isCFS
                    ? actualCardName
                    : cardNameLowercase &&
                        cardNameLowercase.charAt(0).toUpperCase() +
                            cardNameLowercase.slice(1),
                " ",
                " ••••" + card.lastFour)));
    });
}
exports.cardsDetails = cardsDetails;
function isBaseFlowPresent(props, route) {
    var isBaseFlow = props.route.history &&
        props.route.history.includes(route.ADDRESSES.FLOW_BASE);
    return isBaseFlow;
}
exports.isBaseFlowPresent = isBaseFlowPresent;
